<template>
  <div class="page-wrapper">
    <StaffUsers @tab="switchTab" v-if="tab_switch == 'staff'"></StaffUsers>
    <CustomerUser @tab="switchTab" v-if="tab_switch == 'customer'"></CustomerUser>
  </div>
</template>
<script>
import StaffUsers from "./StaffUsers.vue";
import CustomerUser from "./CustomerUser.vue";
export default {
  components: {
    StaffUsers,
    CustomerUser,
  },
  data: () => ({
    tab_switch: "staff",
  }),
  watch: {
    "$route.params.tab"(tab) {
      this.tab_switch = tab;
    },
  },
  mounted() {
    let vm = this;
    if (vm.$route.params.tab) {
      vm.tab_switch = vm.$route.params.tab;
    }
  },
  methods: {
    switchTab(tab) {
      let vm = this;
      vm.tab_switch = tab;
      vm.$router.push({ name: "members", params: { tab: tab } });
    },
  },
};
</script>
<style lang="scss" scoped>
.page-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}
</style>

